import type { RailwayService, RailwaySession } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'

export async function readFailedDeploymentLogs(
  session: RailwaySession,
  cwd: string,
  service: RailwayService
): Promise<string | undefined> {
  const logs = await runRailway(
    session.runner,
    [
      'logs',
      '--service',
      service.name,
      '--environment',
      session.project.environmentName,
      '--lines',
      '100',
      '--json'
    ],
    {
      cwd,
      mode: 'capture',
      timeoutMs: 60_000,
      env: session.env
    }
  )
  return outputTail(`${logs.stdout}\n${logs.stderr}`)
}
